import { ArtifactSourceData, GenericArtifactSourceHolder } from '@/components/canvas/CanvasElementSourceProviders/GenericArtifactFactory'
import { SourceProviderFactory } from '@/components/canvas/CanvasElementSourceProviders/SourceProviderFactory'
import { Camera } from '@/types/Cameras'

export class SingleFrameSourceHolder extends GenericArtifactSourceHolder<ArtifactSourceData> {
  readonly artifactType = 'singleFrame'
}

export class SingleFrameSourceProviderFactory extends SourceProviderFactory<SingleFrameSourceHolder> {
  readonly providerType = 'artifact.singleFrame'

  createSourceHolder(cameraId: string, timestamp: number, camera: Camera): SingleFrameSourceHolder {
    return new SingleFrameSourceHolder(cameraId, timestamp, camera)
  }
}
